// extracted by mini-css-extract-plugin
export var button = "index-module--button--2d942";
export var companyName = "index-module--companyName--eebdc";
export var companyNameArea = "index-module--companyNameArea--260fd";
export var ctaButton = "index-module--ctaButton--224eb";
export var headerArea = "index-module--headerArea--57f51";
export var icon = "index-module--icon--e06fa";
export var logo = "index-module--logo--644b6";
export var navContainer = "index-module--navContainer--61abc";
export var navList = "index-module--navList--eba2f";
export var root = "index-module--root--5949a";
export var text = "index-module--text--ca4d2";